const TRANSLATIONS = [
    {
        name: '_MARKER_Balcony',
        label: 'Balkon',
    },
    {
        name: '_MARKER_Bathroom',
        label: 'Łazienka',
    },
    {
        name: '_MARKER_Bedroom',
        label: 'Sypialnia',
    },
    {
        name: '_MARKER_ChildsRoom',
        label: 'Pokój dziecięcy',
    },
    {
        name: '_MARKER_Closet',
        label: 'Schowek',
    },
    {
        name: '_MARKER_DiningRoom',
        label: 'Jadalnia',
    },
    {
        name: '_MARKER_Garage',
        label: 'Garaż',
    },
    {
        name: '_MARKER_Garden',
        label: 'Ogród',
    },
    {
        name: '_MARKER_Hall',
        label: 'Przedpokój',
    },
    {
        name: '_MARKER_Kitchen',
        label: 'Kuchnia',
    },
    {
        name: '_MARKER_Laundry',
        label: 'Pralnia',
    },
    {
        name: '_MARKER_LivingRoom',
        label: 'Salon',
    },
    {
        name: '_MARKER_Office',
        label: 'Biuro',
    },
    {
        name: '_MARKER_Terrace',
        label: 'Taras',
    },
    {
        name: '_MARKER_Toilet',
        label: 'Toaleta',
    },
    {
        name: '_MARKER_Wardrobe',
        label: 'Garderoba',
    },
    {
        name: '_MARKER_Staircase',
        label: 'Schody',
    },
];

const transformNameIntoLabel = (name: string) => {
    const translation = TRANSLATIONS.find((t) => name.includes(t.name));

    if (translation) return translation.label;
    return '';
};

export default transformNameIntoLabel;
